import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-my-course-lesson-video-route.tsx
var LazyMyCourseLessonVideoRoute = lazy(() => import("./my-course-lesson-video-route-myg_VXP0.js").then((n) => n.n).then((module) => ({ default: module.MyCourseLessonVideoRoute })));
function MyCourseLessonVideoRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseLessonVideoRoute, { ...props })
	});
}
var useMyCourseLessonVideoRoute = () => {
	return useMemo(() => ({ "my-course-lesson-video-route": { component: MyCourseLessonVideoRoute } }), []);
};
//#endregion
export { useMyCourseLessonVideoRoute };
